import { render } from "./dropdown-button-menu.html?vue&type=template&id=eabdc1aa&scoped=true&ts=true"
import script from "./dropdown-button-menu.ts?vue&type=script&lang=ts"
export * from "./dropdown-button-menu.ts?vue&type=script&lang=ts"

import "./dropdown-button-menu.scss?vue&type=style&index=0&id=eabdc1aa&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eabdc1aa"]])

export default __exports__